import cButton from '#themes/default/default/components/button/button.js';

import template from './emailButton.html' with { type: 'html' };

export default {
	name: 'CEmailButton',
	components: {
		cButton
	},
	props: {
		text: {
			type: String,
			default: 'thankYou_openEmail'
		},
		isGmail: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		emailLink() {
			return this.isGmail ? 'https://mail.google.com/' : 'https://login.yahoo.com/';
		}
	},
	methods: {
		openEmail() {
			this.tracking.emailOpenClick({
				order: this.order
			}, this.isGmail ? 'gmail' : 'yahoo');
		}
	},
	template
};
